import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const SkippedArticlesNotice = ({
  count
}) => /*#__PURE__*/_jsx(View, {
  marginBlockStart: "1000",
  marginBlockEnd: "600",
  as: "div",
  children: /*#__PURE__*/_jsx("strong", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "knowledgeContentUI.importArticles.panel.importCompleted.skippedImportMessage",
      options: {
        count
      }
    })
  })
});
SkippedArticlesNotice.propTypes = {
  count: PropTypes.number.isRequired
};
export default SkippedArticlesNotice;